__turbopack_context__.v({
  "className": "lalezar_66fe36e6-module__wzt5rq__className",
});
